
import {getGroups} from '../api/getGroups';
import {setGroupsAction} from '../action';

const setGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGroups(params);
    
            if (data.status === 'success') {
                dispatch(setGroupsAction(data.groups));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGroups
}